import PigletHireTransactionApi from "@/api/piglet/pigletHireTransactionApi";
export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async add({dispatch}, form) {
      try {
        const response = await PigletHireTransactionApi.add(form);
        dispatch('NOTIFY_MSG', 'piglet.notification.book', {root: true});
        return Promise.resolve(response);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async complete({dispatch}, {deliveryId, context}) {
      try {
        await PigletHireTransactionApi.complete(deliveryId, context);
        dispatch('NOTIFY_MSG', 'piglet.notification.book', {root: true});
        return Promise.resolve();
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async read(_, {deliveryId}) {
      try {
        const response = await PigletHireTransactionApi.read(deliveryId);
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async readSingle(_, {deliveryId, timeStamp}) {
      try {
        const response = await PigletHireTransactionApi.read(deliveryId, timeStamp);
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    }
  }
}
